import { Colors, Text } from '@mercator-gcp/grout';
import Dropdown from 'components/elements/Dropdown';
import DropdownItem from 'components/elements/Dropdown/DropdownItem';
import { KeywordDropdown } from 'components/widgets/KeywordDropdown';
import { useDashboardKeywordsAndExclusions } from 'state/dashboard';

const Keywords = () => {
  const {
    updateKeywords: setGlobalKeywords,
    keywords: globalKeywords,
    updateExclusions: setGlobalExclusions,
    exclusions: globalExclusions,
    removeKeyword,
    removeExclusion,
  } = useDashboardKeywordsAndExclusions();

  return (
    <Dropdown
      title="Keywords"
      filterCount={
        globalKeywords.split(',').filter((item) => item !== '').length +
        (globalExclusions
          ? globalExclusions.split(',').filter((item) => item !== '').length
          : 0)
      }
    >
      <DropdownItem>
        <Text.Small as="p" color={Colors.TextQuiet}>
          Search specific keywords within descriptive fields
        </Text.Small>
        <KeywordDropdown
          globalState={globalKeywords}
          setGlobalState={setGlobalKeywords}
          pluralText="keywords"
          singularText="keyword"
          onRemoveItem={removeKeyword}
          inputLabel="keyword input"
        />
      </DropdownItem>
      <DropdownItem>
        <KeywordDropdown
          isExclusion
          globalState={globalExclusions || ''}
          setGlobalState={setGlobalExclusions}
          pluralText="exclusions"
          singularText="exclusion"
          onRemoveItem={removeExclusion}
          inputLabel="keyword input"
        />
      </DropdownItem>
    </Dropdown>
  );
};

export default Keywords;
